import { Component, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { AppConstants } from "src/app/constants/constants";

@Component({
    selector: "base-component",
    template: "<div></div>"
})
export class BaseComponent implements OnDestroy {
  public destroy$: Subject<void> = new Subject<void>();
  private subArray: Array<Subscription> = [];

  scrollToTop(): void {
    const topElement: HTMLElement = document.getElementById(AppConstants.MAIN_HEADER);
    if(topElement) {
        topElement.scrollIntoView({behavior: "smooth", block: "start"});
    }
  }

  ngOnDestroy(): void {
      if (this.subArray && this.subArray.length) {
          this.subArray.forEach(sub => {
              if (sub) {
                  sub.unsubscribe();
              }
          });
      }

      this.destroy$.next();
      this.destroy$.unsubscribe();
  }


  addSubscription(sub: Subscription): void {
      if (sub === null || sub === undefined) {
          return;
      }

      this.subArray.push(sub);
  }

  getSubscriptions(): Subscription[]
  {
    return this.subArray;
  } 
}
